import { render } from "./cpt-scroll-table-option.vue?vue&type=template&id=604b875f"
import script from "./cpt-scroll-table-option.vue?vue&type=script&lang=js"
export * from "./cpt-scroll-table-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__